export function PlateChip({ plate, large }: { plate: string | null | undefined; large?: boolean }) {
  if (!plate) return null;
  return (
    <span className={`rides-plate${large ? ' lg' : ''}`} aria-label={`Number plate ${plate}`}>
      {plate.toUpperCase()}
    </span>
  );
}
